import bxlutils from 'bxl-utils'
function generateUUID() {
  let d = new Date().getTime()
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x7) | 0x8).toString(16)
  })
  return uuid
}
function generateImgName(n = 10) {
  const s: any[] = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < n; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  const uuid = s.join('')
  return uuid
}
function setPcCompatStyle() {
  const ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian
  if (isPc) {
    const html = document.querySelector('html')
    if (html) {
      html.setAttribute('data-dpr', '2')
      html.setAttribute('style', 'font-size:41.4px;')
    }
  }
}
function getColor(color) {
  return (color && `rgba(${color.r},${color.g},${color.b},${color.a})`) || 'rgba(0,0,0,0.8)'
}
const to5num = a => {
  // eslint-disable-next-line no-var
  var a = a.toString()
  //也可以这样写 var c=a.split(/\./);
  const c = a.split('.')
  const num_place = ['', '0', '00', '000', '0000'],
    r = num_place.reverse()
  for (let i = 0; i < c.length; i++) {
    const len = c[i].length
    c[i] = r[len] + c[i]
  }
  const res = c.join('')
  return res
}

const compareMax = (mv, cv) => {
  const mvNum = to5num(mv)
  const cvNum = to5num(cv)
  if (+mvNum > +cvNum) {
    return 1
  } else if (+mvNum < +cvNum) {
    return -1
  } else {
    return 0
  }
}

const sortVersion = templateList => {
  return templateList.sort((a, b) => {
    const reg = /\d+(.\d+){0,2}/g
    const num1 = a.match(reg)[0]
    const num2 = b.match(reg)[0]
    return compareMax(num1, num2)
  })
}

const encode = value => {
  const base64Text = bxlutils.uri.encodeBase64(value)
  return base64Text
}
export default {
  generateUUID,
  setPcCompatStyle,
  getColor,
  sortVersion,
  generateImgName,
  encode,
}
